import React, { FC } from 'react'
import { useHistory } from 'react-router-dom'
import { withProcedureWraper } from '../..'
import { Routes } from '../../../../AppRoutes'
import { Box } from '../../../../components/box'
import { Table } from '../../../../modules/table'
import { getDDMMYYYFormat } from '../../../../helper/dateTimeHelper'
import * as _ from "lodash";
import { TrainingService } from '../../../../services/training/training.service'
import { courseStatus } from '../../../../constants/statusConstants'

export const ProcedureTrainingStudentPage: FC = withProcedureWraper(() => {
  const history = useHistory();
  const getOpeningCourse = () => {
    return TrainingService.getTrainingCourseByStatus(courseStatus.open).then(res => {
      return { data: _.reverse(res), count: res.length }
    }, error => {
      return { data: [], count: 0 }
    });
  }

  return (
    <div className="ProcedureTrainingPlanPage">
      <div className="pd15">
        <Box
          title="Danh sách lớp học"
        >
          <Table
            className="table"
            onRowClick={(item) => history.push(Routes.procedureTrainingCourseStudentDetail.path.replace(':id', item.id))}
            structure={[
              {
                name: 'Lớp học',
                render: (item) => item.fields.Title
              },
              {
                name: 'Ngày tổ chức',
                render: (item) => getDDMMYYYFormat(item.fields.eStartDate)
              },
              {
                name: 'Ngày kết thúc',
                render: (item) => getDDMMYYYFormat(item.fields.eEndDate)
              },
              {
                name: 'Địa điểm tổ chức',
                render: (item) => item.fields.eLocation
              },
              {
                name: 'Số lượng học viên',
                render: (item) => item.fields.eNoOfTrainee
              },
              {
                name: 'Giáo viên',
                render: (item) => item.fields.eTeacher
              },
            ]}
            onFetchData={getOpeningCourse}
          />
        </Box>
      </div>
    </div>
  )
})